import { useEffect, useRef, useState } from "react";
// import CryptoJS from 'crypto-js';
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  addUser,
  setFolderGet,
  setIsCanShare,
  setIsOnlyKeyImages,
  setIsUpload,
  setStudyListButton,
} from "../../app/features/counterSlice";
import logo from "../../asstes/asd.png";
import CustomizedSnackbars from "../../components/CustomizedSnackbars";
import "./auth.css";
// import jwt from 'jsonwebtoken';
// import crypto from 'crypto-browserify';
import CryptoJS from "crypto-js";

import { CircularProgress, CssBaseline } from "@mui/material";
import axios from "axios";
import { useSelector } from "react-redux";
import {
  AWS_Access_Key_Id,
  AWS_Bucket_Name,
  AWS_Region,
  AWS_Secret_Access_Key,
} from "../../constants/bucketCostant";
import { UploadApi } from "../../constants/Constants";
import { decryptLinkSegment } from "../../utilities/shareLinkCrypto";

const isFilled = (value) => value !== "";
const isDate = (value) => value !== "" && !isNaN(new Date(value).getTime());
const isRecoveredText = (value) =>
  value !== "" && !/[\u0000-\u001f\u007f�]/.test(value);
const isRecoveredDate = (value) => /^\d{4}-\d{2}-\d{2}/.test(value);

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      style={{ margin: "0px" }}
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="#00b8ff" href="https://www.dcmcloud.com/" target="_blank">
        DCMCloud
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const theme = createTheme();

const Auth = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [mail, setmail] = useState("");
  const [passwords, setpasswords] = useState("");
  const [canUpload, setUpload] = useState(false);
  const [keyImages, setKeyImages] = useState(false);
  const [isCanSharing, setIsCanSharing] = useState(false);
  const [dates, setdates] = useState("");
  const [Folder, setFolder] = useState("");
  const [severity, setSeverity] = useState("");
  const [loginUser, setLoginUser] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [Filter, setFilter] = useState("");
  const { email, pass, date, FolderName } = useParams();
  const studyListButton = useSelector((state) => state.studyListButton);
  const [Loading, setLoading] = useState(false);
  // Current name of the shared folder when it was renamed after the link was made.
  const renamedFolder = useRef(null);

  // Decrypting
  useEffect(() => {
    const secretKey = "your-secret-key";
    const urlParams = new URLSearchParams(window.location.search);
    const isUpload = urlParams.get("de");
    const isOnlyKeyImages = urlParams.get("key");
    const canShare = urlParams.get("sharing");
    if (email && pass && date && FolderName && isUpload) {
      const newFolderName = FolderName.split(" ")[0];
      const modifiedUpload = isUpload?.replace(/bbbb/g, "/");
      const modifiedKeyImages = isOnlyKeyImages?.replace(/bbbb/g, "/");
      const modifiedSharing = canShare?.replace(/bbbb/g, "/");

      const decryptedUploadBytes = CryptoJS?.AES?.decrypt(
        modifiedUpload,
        secretKey
      );

      const decryptedUpload = decryptedUploadBytes?.toString(
        CryptoJS?.enc?.Utf8
      );

      let decryptedKeyImages = "allimages";
      let decryptedSharing = "noshare";

      if (modifiedKeyImages) {
        const decryptedKeyImagesBytes = CryptoJS?.AES?.decrypt(
          modifiedKeyImages,
          secretKey
        );

        decryptedKeyImages = decryptedKeyImagesBytes?.toString(
          CryptoJS?.enc?.Utf8
        );
      }

      if (modifiedSharing) {
        const decryptedSharingBytes = CryptoJS?.AES?.decrypt(
          modifiedSharing,
          secretKey
        );

        decryptedSharing = decryptedSharingBytes?.toString(CryptoJS?.enc?.Utf8);
      }

      const decryptedEmail = decryptLinkSegment(
        email,
        secretKey,
        isFilled,
        isRecoveredText
      );
      const decryptedPass = decryptLinkSegment(
        pass,
        secretKey,
        isFilled,
        isRecoveredText
      );
      const decryptedDate = decryptLinkSegment(
        date,
        secretKey,
        isDate,
        isRecoveredDate
      );
      const decryptedFolder = decryptLinkSegment(
        newFolderName,
        secretKey,
        isFilled,
        isRecoveredText
      );

      // const textFieldPassword = document.getElementById("password");
      // textFieldPassword.value = decryptedPass;

      setmail(decryptedEmail);
      setpasswords(decryptedPass);
      setdates(decryptedDate);
      setUpload(decryptedUpload === "yestofileupload" ? true : false);
      setKeyImages(decryptedKeyImages === "onlykeyimages" ? true : false);
      setIsCanSharing(decryptedSharing === "yesshare" ? true : false);

      if (
        decryptedFolder.includes(",") &&
        decryptedFolder.includes("[") &&
        decryptedFolder.includes("]")
      ) {
        let list = JSON.parse(decryptedFolder);
        // let getlist= list?.split(",")
        setFolder(list);
      } else {
        setFolder(decryptedFolder);
      }

      dispatch(setStudyListButton(true));
      // //console.log('Decrypted Email:', decryptedEmail);
      // //console.log('Decrypted Password:', decryptedPass);
      // //console.log('Decrypted Date:', decryptedDate);
    }
    // In this code, you first encrypt the data (whichtoke  you've done), and then you decrypt it by calling CryptoJS.AES.decrypt on the encrypted values using the same secretKey. Finally, you log the decrypted values to the console.
  }, [email, pass, date, FolderName]);

  const checkLinkValidity = async () => {
    try {
      let folderName;
      try {
        const parsedFolder = JSON.parse(Folder);
        folderName = Array.isArray(parsedFolder) ? "Multi" : Folder;
      } catch {
        folderName = Array.isArray(Folder) ? "Multi" : Folder;
      }

      const data = {
        bucketName: AWS_Bucket_Name(),
        
        Region: AWS_Region(),
        folderName,
        link: window.location.href.split("%20")[0],
      };
      const response = await axios.post(`${UploadApi}/apiUpload/valid`, data);

      if (response.data.success) {
        renamedFolder.current = response.data.folderName || null;
        return response.data.success;
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  };

  const handleSubmit = async (event) => {
    setLoading(true);
    event.preventDefault();
    event.persist();
    const data = new FormData(event.currentTarget);
    const password = data.get("password");
    let email = mail;
    const somevalue = await checkLinkValidity();
    var cridentials;
    if ((mail, passwords, dates)) {
      cridentials = [
        {
          email: mail,
          password: passwords,
          date: dates,
        },
      ];
    }

    var user = {};

    // const email = data.get("email");
    user = cridentials.filter((item) => {
      if (
        item.email === email ||
        item.email === email ||
        item.email === email
      ) {
        // Store the token in local storage
        return item;
      }
      // //console.log(email,"mailmailmail")
      // //console.log(item.email,"mailmailmial");
    });
    if (user.length === 0) {
      setIsOpen(true);
      setMessage("Email/Password is Incorrect.");
      setSeverity("error");
      setTimeout(() => {
        setIsOpen(false);
      }, 3000);
      setLoading(false);
    } else {
      if (user[0]["password"] === password) {
        if (
          (new Date(user[0]["date"]).getTime() >
            new Date(new Date().setHours(0, 0, 0, 0)).getTime() ||
            new Date(user[0]["date"]).getTime() ===
              new Date(new Date().setHours(0, 0, 0, 0)).getTime()) &&
          somevalue
        ) {
          let newFolder;
          if (typeof Folder === "string") {
            try {
              const parsedFolder = JSON.parse(Folder);
              newFolder = parsedFolder.length == 1 ? parsedFolder[0] : Folder;
            } catch (error) {
              newFolder = Folder;
            }
          } else {
            newFolder = Folder;
          }
          dispatch(addUser({ email: user[0]["email"], id: user[0]["id"] }));
          dispatch(
            setFolderGet({ FolderName: renamedFolder.current || newFolder })
          );
          if (email != "operations@medicalrecordcollation.com") {
            dispatch(setStudyListButton(true));
            // //console.log(studyListButton,"done");
          }
          dispatch(setIsUpload(canUpload));
          dispatch(setIsOnlyKeyImages(keyImages));
          dispatch(setIsCanShare(isCanSharing));
          setLoading(false);
          applyAuth(user[0]["date"]);
          localStorage.setItem("jkbnm", "dmewtnwkndghn");
          // //console.log(mail,"mailamail");
          // localStorage.setItem("FolderGet",mail)
          setTimeout(() => {
            navigate("/");
          }, 2000);
        } else {
          setIsOpen(true);
          setMessage("Account is expired.");
          setSeverity("error");
          setTimeout(() => {
            setIsOpen(false);
          }, 3000);
          setLoading(false);
        }
      } else {
        setIsOpen(true);
        setMessage("Invalid Password.");
        setSeverity("error");
        setTimeout(() => {
          setIsOpen(false);
        }, 3000);
        setLoading(false);
      }
    }
  };

  const applyAuth = async (expiryDate) => {
    try {
      const response = await axios.post(
        `${UploadApi}/user/getShareAuth`,
        {
          expiresAt: expiryDate,
        },
        {
          headers: {
            "x-api-key": process.env.React_App_Api_Key,
          },
        }
      );

      if (response.data) {
        localStorage.setItem("token", response.data.token);
      }
    } catch (error) {}
  };

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxHeight="xs" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            // border:"1px solid red",
            padding: "25px 15px",
            borderRadius: "8px",
          }}
          className="boxShadow"
        >
          {/* <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                    </Avatar> */}
          <img src={logo} width="200px" />
          {/* <Typography component="h1" variant="h5">
                        Sign in
                    </Typography> */}
          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{ mt: 1 }}
          >
            {/* {mail == Folder && (
              <TextField
                onChange={() => setLoading(false)}
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email/ID"
                name="email"
                autoComplete="email"
                autoFocus
                disabled={mail == Folder}
              />
            )} */}

            <TextField
              onChange={() => setLoading(false)}
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
            />
            {/* <FormControlLabel
                  control={<Checkbox value="remember" color="primary" />}
                  label="Remember me"
              /> */}

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              style={{
                height: "50px",
                background: "#5582c3",
                padding: "8.5px 6px",
                fontSize: "inherit",
                outline: "none", // Remove the black border when clicked
              }}
              // onClick={handleClick}
            >
              {Loading ? (
                <CircularProgress
                  color={"inherit"}
                  style={{ height: "25px", width: "25px" }}
                />
              ) : (
                "Sign In"
              )}
            </Button>
            {/* <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              style={{
                background: "#5582c3",
                padding: "8.5px 6px",
                fontSize: "inherit",
              }}
            >
              {Loading ? <Loader /> : " Sign In"}
            </Button> */}

            {/* <Grid container>
            <Grid item xs>
                <Link href="#" variant="body2">
                    Forgot password?
                </Link>
            </Grid>
            <Grid item>
                <Link href="#" variant="body2">
                    {"Don't have an account? Sign Up"}
                </Link>
                </Grid>
            </Grid> */}
          </Box>
          <Copyright sx={{ mt: 8, mb: 4 }} />
        </Box>
      </Container>
      <CustomizedSnackbars
        isOpen={isOpen}
        severity={severity}
        message={message}
      />
    </ThemeProvider>
  );
};

export default Auth;
